<script setup>
import { ref, onMounted } from 'vue';
import LandingComparisonGraph from './LandingComparisonGraph.vue';
import LandingComparisonTable from './LandingComparisonTable.vue';
import LandingCtaButton from './LandingCtaButton.vue';
import { useScrollAnimations } from '@/composables/useScrollAnimations';

const { animateInView, slideUp } = useScrollAnimations();
const sectionRef = ref(null);

onMounted(() => {
    if (sectionRef.value) {
        animateInView(sectionRef.value, () => {
            // Main section animation triggers usually handled inside child components for specific elements 
            // but we can fade in the whole container or table here.
            const tableComp = sectionRef.value.querySelector('.table-container');
            if (tableComp) slideUp(tableComp, 0.2);
        }, 0.1);
    }
});
</script>

<template>
    <div class="py-24" ref="sectionRef">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">

            <!-- Header -->
            <!-- Header -->
            <h2 class="text-3xl font-bold tracking-tight text-white sm:text-5xl mb-16 text-center"
                v-html="$t('landingPage.v2.comparison.header')">
            </h2>

            <!-- Graph Section -->
            <div class="mb-24">
                <LandingComparisonGraph />
            </div>

            <!-- Table Section -->
            <div class="table-container opacity-0">
                <LandingComparisonTable />
            </div>

            <!-- CTA -->
            <div class="mt-16 flex items-center justify-center">
                <LandingCtaButton sectionName="Comparison" :text="$t('landingPage.v2.cta.comparison')" />
            </div>
        </div>
    </div>
</template>

<style scoped></style>
